import axios from 'axios';

import {
  AuditFilters,
  AuditSearchCarsResponse,
  CarAuditResponse,
} from '../interfaces/Audit';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const authHeader = (): Record<string, string> => {
  const token = localStorage.getItem('authToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export async function searchAuditCars(query: string, page: number = 1, limit: number = 10) {
  const response = await axios.get<AuditSearchCarsResponse>(`${BACKEND_URL}/cars/audit/search`, {
    params: { query, page, limit },
    withCredentials: true,
    headers: authHeader(),
  });

  return response.data;
}

export async function fetchCarAudit(carId: string, filters: AuditFilters) {
  const response = await axios.get<CarAuditResponse>(`${BACKEND_URL}/cars/audit/${carId}`, {
    params: filters,
    withCredentials: true,
    headers: authHeader(),
  });

  return response.data;
}

/**
 * Linha do tempo da aba FEEDBACK (at-90, ADR 0042).
 *
 * ⚠️ Rota SEPARADA, não um parâmetro da rota de cima: a curadoria dos tipos de evento e o resumo
 * reduzido do veículo são do SERVIDOR. Se o recorte viesse por query, bastaria trocá-la para o
 * setor de EVENTOS receber horas, checklists e edições de dados — que é justamente o que a
 * projeção mínima do papel (ADR 0039) esconde.
 */
export async function fetchCarAuditFeedback(carId: string, filters: AuditFilters) {
  const response = await axios.get<CarAuditResponse>(
    `${BACKEND_URL}/cars/audit/${carId}/feedback`,
    {
      params: filters,
      withCredentials: true,
      headers: authHeader(),
    },
  );

  return response.data;
}
